import { observer } from 'mobx-react-lite';
import { EntityItem } from './entity-item';
import { useOpenBoloPanel } from '../../../bolos/bolo-panel/use-open-bolo-panel';
import { WorkspacePanel } from '../../workspace-panel';

export const BoloItem = observer(
    (props: {
        isHistorical?: boolean;
        title: string;
        boloId?: number;
        boloNumber?: string;
        workspacePanel?: WorkspacePanel;
    }) => {
        const openBoloPanel = useOpenBoloPanel();

        return (
            <EntityItem
                title={props.title}
                icon="Bolo"
                isPanelFocused={!!props.workspacePanel?.isFocused}
                entityNumber={props.boloNumber}
                onClick={() => {
                    if (props.isHistorical) {
                        openBoloPanel({
                            boloId: props.boloId,
                            shouldFocus: true,
                        });
                    } else {
                        props.workspacePanel?.focus?.();
                    }
                }}
                onClose={props.workspacePanel ? () => props.workspacePanel?.close?.() : undefined}
            />
        );
    }
);
